module.exports = __webpack_public_path__ + "img/addregistericon_active.0b3623aa.svg";